import { useState, useEffect } from 'react';


/*  
    
    ATTENTION:

    This is all some straight 100% certified vibe code right here. 
    Ask me what it does and I will have no idea.
    I just know this thing is used to wrap some of the little analysis visual components to have them fade in and out when the user toggles whether or not they want to see the comparison data

    
*/

/**
 * FadeTransition component that provides smooth fade in/out transitions
 * Compatible with React 19 (no findDOMNode dependency)
 * 
 * @param {boolean} in - Whether the component should be visible
 * @param {number} timeout - Transition duration in milliseconds (default: 500)
 * @param {boolean} unmountOnExit - Whether to remove from DOM when hidden (default: true)
 * @param {React.ReactNode} children - The content to transition
 * @param {string} className - Additional CSS classes
 * @param {object} style - Additional inline styles
 */
export default function FadeTransition({ 
  in: isVisible, 
  timeout = 500, 
  unmountOnExit = true, 
  children, 
  className = '', 
  style = {} 
}) {
  const [shouldRender, setShouldRender] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
      // Small delay to ensure DOM is ready before starting fade in
      const timeoutId = setTimeout(() => setShow(true), 10);
      return () => clearTimeout(timeoutId);
    } else {
      setShow(false);
      // Remove from DOM after fade out completes
      const timeoutId = setTimeout(() => {
        if (unmountOnExit) {
          setShouldRender(false);
        }
      }, timeout);
      return () => clearTimeout(timeoutId);
    }
  }, [isVisible, timeout, unmountOnExit]);

  // If unmountOnExit is false, always render but control opacity
  const shouldAlwaysRender = !unmountOnExit;
  const isRendered = shouldRender || shouldAlwaysRender;

  if (!isRendered) {
    return null;
  }

  return (
    <div
      className={className}
      style={{
        opacity: show ? 1 : 0,
        transition: `opacity ${timeout}ms ease-in-out`,
        ...style
      }}
    >
      {children}
    </div>
  );
} 